import { password, Tokens } from "marvin-auth-kit";
import { useMutation, UseMutationOptions } from "react-query";
import { APIError } from "src/types";

type usePasswordResetConfirmMutationOptions = UseMutationOptions<Tokens, APIError[] | Error, string, unknown>;
export function usePasswordResetConfirmMutation(token: string, options?: usePasswordResetConfirmMutationOptions) {
  async function mutationFn(token: string, pass: string) {
    const response = await password.confirm(token, pass);
    return response;
  }

  return useMutation((password) => mutationFn(token, password), options);
}
